// extracted by mini-css-extract-plugin
export var dataCell = "_q2-2";
export var dataRow = "_q2-0";
export var headerRow = "_q2-1";